import PropTypes from 'prop-types';
import RegisterResultChecker from 'features/SubmitProjectProposal/pages/RegisterResultChecker';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function RegisterResultCheckerPage({ isLiquidation }) {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          background: 'white',
        }}
      >
        <RegisterResultChecker isLiquidation={isLiquidation} />
      </Layout>
    </LayoutProvider>
  );
}

RegisterResultCheckerPage.propTypes = {
  isLiquidation: PropTypes.bool,
};

RegisterResultCheckerPage.defaultProps = {
  isLiquidation: false,
};

export default RegisterResultCheckerPage;
